export const MESSAGING_STATES = [
  {
    label: 'Send Automatically',
    value: 'automatic',
  },
  {
    label: 'Queue Draft',
    value: 'draft',
  },
  {
    label: "Don't Send",
    value: 'off',
  },
];

export const MESSAGING_STATE_ICONS = {
  automatic: 'send-auto',
  draft: 'draft',
  off: 'does-not-send',
};

export const MESSAGING_STATE_FLY_ICONS = {
  automatic: 'send-auto',
  draft: 'draft',
  off: 'does-not-send',
};
